// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","cancelButton":"G5afba1"};